import React, { Component } from 'react';
import classNames from 'classnames';
import Col from '../../../lib/col';
import noop from 'lodash/noop';
import CheckBox from '../../../lib/checkbox';
export default class ScreeningOption extends Component {
    constructor() {
        super(...arguments);
        this.onMouseLeave = () => {
            const { optionkey, value, onMouseLeave } = this.props;
            const info = {
                key: optionkey,
                value,
            };
            if (onMouseLeave) {
                onMouseLeave(info);
            }
        };
        this.onMouseEnter = () => {
            const { optionkey, value, onMouseEnter } = this.props;
            const info = {
                key: optionkey,
                value,
            };
            if (onMouseEnter) {
                onMouseEnter(info);
            }
        };
        this.onClick = () => {
            const { optionkey, multiple, onClick, onSelect, onDeselect, value, isSelected } = this.props;
            const info = {
                key: optionkey,
                value,
            };
            if (onSelect && onClick) {
                onClick(info);
                if (multiple) {
                    if (isSelected && onDeselect) {
                        onDeselect(info);
                    }
                    else {
                        onSelect(info);
                    }
                }
                else {
                    onSelect(info);
                }
            }
        };
    }
    render() {
        const { prefixCls, disabled, children, optionkey, active, style, multiple, onMouseDown, isSelected, span, order, offset, push, pull, xs, sm, md, lg, xl, xxl, optionRender, } = this.props;
        const ScreeningOptionPrefix = `${prefixCls}-option`;
        const className = classNames(ScreeningOptionPrefix, {
            [`${ScreeningOptionPrefix}-disabled`]: disabled,
            [`${ScreeningOptionPrefix}-selected`]: isSelected,
            [`${ScreeningOptionPrefix}-active`]: active,
        });
        const attrs = {
            optionkey,
            className,
            span,
            order,
            offset,
            push,
            pull,
            xs,
            sm,
            md,
            lg,
            xl,
            xxl,
        };
        let mouseEvent = {};
        if (!disabled) {
            mouseEvent = {
                onClick: this.onClick,
                onMouseLeave: this.onMouseLeave,
                onMouseEnter: this.onMouseEnter,
                onMouseDown,
            };
        }
        const checkbox = multiple ? React.createElement(CheckBox, { checked: isSelected }) : null;
        return (React.createElement(Col, Object.assign({}, attrs, { style: style }),
            React.createElement("div", Object.assign({ className: `${ScreeningOptionPrefix}-content` }, mouseEvent), optionRender || (React.createElement(React.Fragment, null,
                checkbox,
                children)))));
    }
}
ScreeningOption.defaultProps = {
    onSelect: noop,
    onMouseEnter: noop,
    onMouseLeave: noop,
    onMouseDown: noop,
    isSelected: false,
};
